import { action } from 'satcheljs';

export const saveReadingPanePositionOption: () => {} = action('saveReadingPanePositionOption');
